<template>
	<div class="text-center">
		<v-dialog v-model="dialog" width="800" persistent>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					:x-large="$vuetify.breakpoint.smAndUp"
					fab
					color="indigo"
					dark
					v-bind="attrs"
					v-on="on"
				>
					<v-icon>mdi-autorenew</v-icon>
				</v-btn>
			</template>

			<v-card>
				<v-card-title class="font-weight-light lighten-2 d-flex">
					Obtener renuevo personalizado
				</v-card-title>

				<v-stepper v-model="stepper" vertical flat>
					<v-stepper-step
						:complete="stepper > 1"
						step="1"
						:rules="[() => checkForm()]"
					>
						Rellene el formulario
						<small
							>Documentación y número teléfono a consultar</small
						>
					</v-stepper-step>

					<v-stepper-content step="1">
						<v-card class="pa-2" elevation="0">
							<div v-if="!isLoadingRenuevo">
								<v-select
									clearable
									prepend-inner-icon="mdi-passport"
									outlined
									shaped
									item-value="human"
									item-text="encoded"
									v-model="typeDocument"
									:items="opciones.cliente.tipoDocumento"
									label="Tipo de documento cliente o empresa"
								></v-select>
								<div id="company" v-if="typeDocument == 'CIF'">
									<v-text-field
										clearable
										prepend-inner-icon="mdi-passport"
										outlined
										shaped
										v-model="documentCompany"
										label="Documento CIF de la empresa"
									></v-text-field>
									<v-select
										clearable
										prepend-inner-icon="mdi-passport"
										outlined
										shaped
										item-value="human"
										item-text="encoded"
										v-model="typeDocumentRepresentative"
										:items="['NIF', 'NIE']"
										label="Tipo de documento del representante"
									></v-select>
								</div>
								<v-text-field
									clearable
									prepend-inner-icon="mdi-passport"
									outlined
									shaped
									v-model="document"
									:label="
										typeDocument == 'CIF'
											? `Documento del representante`
											: `Documento del cliente`
									"
								></v-text-field>
								<v-combobox
									clearable
									prepend-inner-icon="mdi-phone"
									:error-messages="numberErrors"
									outlined
									shaped
									v-model="numberSelected"
									:items="info.contactNumbers"
									label="Teléfono de Contacto"
								></v-combobox>
							</div>
							<div v-else>
								<v-progress-circular
									indeterminate
									color="primary"
									size="64"
									style="width: 100%; heigth: 100%"
								></v-progress-circular>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="stepper > 2" step="2">
						Información sobre el renuevo
					</v-stepper-step>

					<v-stepper-content step="2">
						<v-card class="pa-2">
							<v-row justify="center">
								<div
									id="info-renuevo"
									class="px-6"
									:class="renuevoData ? 'py-2' : ''"
								></div>
							</v-row>
							<v-row justify="center">
								<v-progress-linear
									v-if="isLoadingRenuevo"
									indeterminate
									color="#2962B1"
									size="64"
									style="width: 100%"
								></v-progress-linear>
								<v-chip
									v-if="
										renuevoData && renuevoData.estado != -1
									"
									color="#2B67BB"
									label
									x-large
									:disabled="isLoadingRenuevo"
									dark
									class="my-6 justify-center"
									style="width: 60%"
									@click="sendRequestForRenuevoPDF"
								>
									<v-icon left> mdi-download </v-icon>
									<p
										class="overline mb-0"
										style="font-size: 1rem !important"
									>
										Descargar PDF
									</p>
								</v-chip>
								<div v-else>
									<v-progress-circular
										indeterminate
										color="primary"
										size="64"
										style="width: 100%; heigth: 100%"
									></v-progress-circular>
								</div>
							</v-row>
						</v-card>
					</v-stepper-content>
				</v-stepper>

				<!-- <v-divider></v-divider> -->

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="stepper == 2"
						color="warning"
						@click="stepper = 1"
						>Atras</v-btn
					>
					<v-btn
						v-if="stepper == 1"
						color="green"
						text
						@click="resetForm()"
						:disabled="isLoadingRenuevo"
					>
						Resetear
					</v-btn>
					<v-btn
						depressed
						v-if="stepper == 1"
						color="primary"
						@click="sendRenuevoFetch()"
						:disabled="!checkForm() || isLoadingRenuevo"
					>
						Continuar
					</v-btn>
					<v-btn
						color="error"
						text
						@click="closeDialog()"
						:disabled="isLoadingRenuevo"
					>
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	name: ' RenuevoView',
	props: {
		info: {
			type: Object,
			default: () => ({}),
		},
	},
	data: () => ({
		dialog: false,
		stepper: 1,
		numberErrors: [],
		numberSelected: null,
		typeDocument: null,
		document: null,
		documentCompany: null,
		typeDocumentRepresentative: null,
	}),
	methods: {
		closeDialog() {
			this.dialog = false;
			this.stepper = 1;
			this.numberSelected = null;
		},
		checkForm() {
			if (this.typeDocument == 'CIF') {
				return !(
					this.numberSelected == null ||
					this.documentCompany == null ||
					this.typeDocumentRepresentative == null ||
					this.document == null ||
					this.typeDocument == null
				);
			} else {
				return !(
					this.numberSelected == null ||
					this.document == null ||
					this.typeDocument == null
				);
			}
		},
		resetForm() {
			if (this.info) {
				if (this.info.documentType == 'CIF') {
					this.documentCompany = this.info.document;
					this.typeDocumentRepresentative = null;
					this.document = null;
				} else {
					this.document = this.info.document;
				}
				this.typeDocument = this.info.documentType;
				this.numberSelected = null;
			}
		},
		sendRenuevoFetch() {
			this.$store.commit('teletrabajo/renuevoData', null);
			document.getElementById('info-renuevo').innerHTML = '';
			let documentParam = {
				type:
					this.typeDocument == 'CIF'
						? this.typeDocumentRepresentative
						: this.typeDocument,
				identificationId: this.document,
			};
			if (this.typeDocument == 'CIF') {
				documentParam['cif'] = this.documentCompany;
			}
			this.$store
				.dispatch('teletrabajo/fetchTtClienteRenuevo', {
					documentoParam: documentParam,
					msisdnParam: this.numberSelected,
				})
				.then(() => {
					this.stepper = 2;
				});
		},
		sendRequestForRenuevoPDF() {
			this.$store.dispatch('teletrabajo/downloadPdfRenuevo2', {
				documentoParam: {
					type: this.typeDocument,
					identificationId:
						this.typeDocument == 'CIF'
							? this.documentCompany
							: this.document,
				},
				msisdnParam: this.numberSelected,
			});
		},
	},
	computed: {
		opciones() {
			return JSON.parse(localStorage.getItem('opciones'));
		},
		// ...mapState('util', {
		//     opciones: (state) => state.opciones,
		// }),
		...mapState('teletrabajo', {
			isLoadingRenuevo: (state) =>
				state.CompleteViewTtForm.isLoadingRenuevo,
			renuevoData: (state) => state.CompleteViewTtForm.renuevoData,
		}),
	},
	watch: {
		dialog: {
			immediate: true,
			handler(newValue, oldValue) {
				if (newValue) {
					this.resetForm();
				}
			},
		},
		numberSelected: {
			immediate: true,
			handler(val) {
				let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;

				if (val && typeof val == 'string' && !regexTelefono.test(val)) {
					this.numberErrors =
						'El número introducido no es correcto y se ha eliminado';
					this.numberSelected = null;

					setTimeout(() => {
						this.numberErrors = [];
					}, 2500);
				}
			},
		},
		renuevoData: {
			inmmediate: true,
			handler() {
				if (this.renuevoData && this.renuevoData?.infoPerm) {
					document
						.getElementById('info-renuevo')
						.insertAdjacentHTML(
							'afterbegin',
							this.renuevoData.infoPerm
						);
				}
			},
		},
		typeDocument: {
			immediate: true,
			handler(newValue, oldValue) {
				if (
					newValue &&
					newValue != 'CIF' &&
					(oldValue == null || oldValue == 'CIF')
				) {
					this.documentCompany = null;
					this.typeDocumentRepresentative = null;
				}
			},
		},
	},
};
</script>

<style>
</style>